import axios from "../../axios";

const header = (token) => ({
  headers: {
    Authorization: "Bearer " + token
  }
});

const baseUrl = () => process.env.VUE_APP_API_BASE_URL + '/api/banners';
export default {
  list(token, params = {}) {
    axios.defaults.baseURL = baseUrl();
    return axios.get('', { params, ...header(token) });
  },

  create(token, payload) {
    axios.defaults.baseURL = baseUrl();
    return axios.post('', payload, header(token));
  },

  update(token, id, payload) {
    axios.defaults.baseURL = `${baseUrl()}/${id}`;
    return axios.put('', payload, header(token));
  },

  remove(token, id) {
    axios.defaults.baseURL = `${baseUrl()}/${id}`;
    return axios.delete('', header(token));
  }
}